import api from '@/utils/axios';

/**
 * Read-only organogram tree: executives + C-suite branches, departments with
 * sub-department/team nesting and employee cards, plus unassigned employees
 * (global scope only).
 * Access: any signed-in user sees the full structure.
 * `can_open_profile` on a card is the only signal for opening that person's profile.
 */
export const fetchOrganogramTree = async ({ employment_status = null } = {}) => {
  const body = {};
  if (employment_status) body.employment_status = employment_status;
  const response = await api.post('organogram/tree/get', body);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to load organogram');
  }
  const data = response.data.data || {};
  const scopeMeta = data.scope_meta || {};
  return {
    c_suite: Array.isArray(data.c_suite) ? data.c_suite : [],
    executives: Array.isArray(data.executives) ? data.executives : [],
    branches: Array.isArray(data.branches) ? data.branches : [],
    departments: Array.isArray(data.departments) ? data.departments : [],
    unassigned: Array.isArray(data.unassigned) ? data.unassigned : [],
    total_employees: Number(data.total_employees || 0),
    scope: data.scope || scopeMeta.type || 'global',
    scope_meta: {
      type: scopeMeta.type || data.scope || 'global',
      department_id: scopeMeta.department_id ?? null,
    },
    warnings: Array.isArray(data.warnings) ? data.warnings : [],
  };
};
